<div class="user-table-container">
  <p-table
    [columns]="cols"
    [value]="finalListOfUsers"
    [tableStyle]="{ 'min-width': '50rem' }"
    [paginator]="true"
    [rows]="5"
    [rowsPerPageOptions]="[5, 10, 15, 20]"
    sortMode="multiple"
    dataKey="user_id"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th pSortableColumn="email">
          Usuario
          <p-sortIcon field="email"></p-sortIcon>
        </th>
        <th pSortableColumn="currentRole">
          Rol
          <p-sortIcon field="currentRole"></p-sortIcon>
        </th>
        <th>Servicios</th>
        <th pSortableColumn="status">
          Estado
          <p-sortIcon field="status"></p-sortIcon>
        </th>
        <th>Creado el</th>
        <th>Última Conexión</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        <td>
          <div class="flex items-center">
            <p-avatar
              image="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAMAAACnDzTfAAAArlBMVEX7yC77yC3+yC3+xy/+xy39yC39yCz9yCv8ySr+xjH/yyz+zjf/zDr3zCf/0C7tvz6bfi1WRh1FNRU/LxN/Zyqihi4AAAB2YCT/0DaNdCsAAAOqiSzCnzRGNhS9mS7aszzjvEPqwDefj2trZ2QdEQCUdyr2zENhTBtsWCDKysn////Y2dbwxkoQBAhuZ1txcG0XEApdX2J6e3mMcSPp6eiUdhuQkI3ktDgyJhJKOxl6O9euAAABQ0lEQVR4AbWQVYLDMAwFZZCsOCm3WmaGMt//YmuV8XMnYD+PGcAYAwY2r8Z1sucBdxYPSGiJyJK1hESESEpKBCGBDj0pfoXlLHNBHaFHJm/9FmZyXl1wWYj5HkUOzOq4VK5Ua/U9Gs3cASHZoiVHXJQRnPGXVyLX6Vmh9Wu5iQye4+3S3N0/PD7eNkSNyJNlyCBfxouH5xd5fXv/EOXzEhFcfBClfvv1/f2TRv++ptR+ss4Bx5vFUjed70RX5OpGpPcQMzZp3JUo1b66Qao9yGcl6pWAK9++vVXfWkMZfX+PRN1Trio5JhtjLJfHIpNJT9207M3SGXZIkIX7zeme2DMtXPqIOYRilpr1nG+Rgip1K+LDtSi1ImCKe87Ep+asN78pAtGhcw7zoihiSUcdOKbgGEuZ98duy/86tOhR8Vps0PQHIRAktypFIpIAAAAASUVORK5CYII="
              class="mr-2"
              shape="circle"
            ></p-avatar>
            <span class="inline-flex flex-col">
              <span class="font-bold">{{ rowData.email }}</span>
              <span class="text-sm text-gray-500">{{ rowData.first_name }} {{ rowData.last_name }}</span>
            </span>
          </div>
        </td>
        <td>
          <span class="text-sm">{{ rowData.currentRole }}</span>
        </td>
        <td>
          <div class="service-access-list">
            <span *ngFor="let svc of rowData.serviceAccess" class="service-chip" [attr.data-service]="svc.key">
              <span class="service-name">{{ svc.displayName }}</span>
              <span *ngIf="svc.roleLabel" class="service-role">{{ svc.roleLabel }}</span>
            </span>
            <span *ngIf="!rowData.serviceAccess || rowData.serviceAccess.length === 0" class="text-xs text-gray-400">—</span>
          </div>
        </td>
        <td>
          <p-tag [severity]="getUserStatusSeverity(rowData)" [value]="getUserStatusLabel(rowData)"></p-tag>
        </td>
        <td>
          <div class="flex-1 flex flex-col gap-2" *ngIf="rowData.created_at">
            <span class="mb-0 text-xs">{{ formatDate(rowData.created_at, 'date') }}</span>
            <span class="mt-0 text-xs">{{ formatDate(rowData.created_at, 'time') }}</span>
          </div>
          <span class="text-xs text-gray-500" *ngIf="!rowData.created_at">-</span>
        </td>
        <td>
          <div class="flex-1 flex flex-col gap-2" *ngIf="rowData.last_login_at">
            <span class="mb-0 text-xs">{{ formatDate(rowData.last_login_at, 'date') }}</span>
            <span class="mt-0 text-xs">{{ formatDate(rowData.last_login_at, 'time') }}</span>
          </div>
          <span class="text-xs text-gray-500" *ngIf="!rowData.last_login_at">-</span>
        </td>
        <td>
          <div class="flex gap-1">
            <p-button icon="pi pi-wrench" pTooltip="Editar" tooltipPosition="top" [rounded]="true" [text]="true" (click)="openDialogToEditUser(rowData)">
            </p-button>

            <!-- Botón Habilitar/Deshabilitar según estado en la organización actual -->
            <p-button
              *ngIf="rowData.currentMembership"
              [icon]="rowData.currentMembership.status === 'inactive' ? 'pi pi-lock-open' : 'pi pi-lock'"
              [pTooltip]="rowData.currentMembership.status === 'inactive' ? 'Habilitar acceso' : 'Deshabilitar acceso'"
              tooltipPosition="top"
              [rounded]="true"
              [text]="true"
              [disabled]="isPendingStatus(rowData.currentMembership.status)"
              [severity]="rowData.currentMembership.status === 'inactive' ? 'success' : 'warn'"
              (click)="
                rowData.currentMembership.status === 'inactive'
                  ? openAlertToEnableUser(rowData, currentOrganizationId || '')
                  : openAlertToDisableUser(rowData, currentOrganizationId || '')
              "
            >
            </p-button>

            <p-button
              icon="pi pi-trash"
              pTooltip="Eliminar permanentemente"
              tooltipPosition="top"
              [rounded]="true"
              [text]="true"
              severity="danger"
              (click)="openAlertToDeleteUserPermanently(rowData)"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-toast />
  <p-confirmDialog> </p-confirmDialog>
</div>
